const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const PostCheckoutQuery: any = {
    GetBlockedShippingCompanyForCustomerList: Backofficebff + '/v1/postcheckout/getblockedshippingcompany',
    GetRejectedReturnList: Backofficebff + '/v1/postcheckout/GetRejectedReturnList',
    GetDigitalCardTemplates: Backofficebff + '/v1/postcheckout/get-digital-card-templates',
    GetWalletTransactionByCustomerId: Backofficebff + '/v1/postcheckout/get-wallet-transaction-by-customer-id',
    GetShippingCompanies: Backofficebff + '/v1/postcheckout/get-shipping-company',
    GetFiscal: Backofficebff + '/v1/postcheckout/get-fiscal',
    GetFiscalType: Backofficebff + '/v1/postcheckout/get-fiscal-type',
    GetFiscalList: Backofficebff + '/v1/postcheckout/get-fiscal-list',
    GetFinanceReport: Backofficebff + '/v1/reportslist/get-finance-report',
};
